// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_JYP","cls2":"AccountMenu-cls2_KWT AccountMenu-cls1_JYP"};